import React, { useState } from 'react'
import { Icon, Modal } from "antd"

function MarkPackagedPageDetails(props) {
    const { loading, processingOrder, totalItems, orders = [], reset, onMarkPackaged, onCancel } = props
    const { brand, barcode = {} } = { ...processingOrder }
    const { tags = [] } = { ...barcode }
    const [hoverOrder, setHoverOrderState] = useState(false)
    const [visible, setVisible] = useState(false)
    const isMadeInVN = tags.includes('made_vn')

    const maxCols = ({
        1: 12,
        2: 6,
        3: 4
    })[totalItems] || 4

    const handleMarkPackaged = () => {
        onMarkPackaged()
        // const modal = Modal.confirm({
        //     title: 'Thông báo',
        //     content: <>Bạn chắc chắn muốn đánh dấu
        //         đơn <strong>{getBarcodeString()}</strong> đã đóng gói?</>,
        //     onOk: () => {
        //         onMarkPackaged()
        //         modal.destroy()
        //     },
        //     okText: 'Tiếp tục',
        //     cancelText: 'Hủy',
        //     onCancel
        // })
    }

    return <div className="MarkPackagedPageDetails">
        <div className="BasicInfo d-flex flex-wrap justify-content-between mt-2 mb-2">
            <div className="leftContent">
                <span className="InfoType">{processingOrder.type}</span>
                <span className="InfoSize badge bg-secondary">{processingOrder.size}</span>
                <span className="InfoSize badge bg-secondary">{processingOrder.color}</span>
                <span className="InfoSize badge bg-secondary">{!!processingOrder.designBack && "Back"}</span>
                <span className="InfoSize badge bg-secondary">{!!processingOrder.designFront && "Front"}</span>
                <span className="InfoSize badge bg-secondary">{!!processingOrder.designHood && "Hood"}</span>
                <span className="InfoSize badge bg-secondary">{!!processingOrder.designSleeves && "Sleeves"}</span>
                <span className="InfoSize badge bg-secondary">{processingOrder.item_number}</span>
                {
                    brand && brand.name && <span className="InfoBrand badge text-bg-danger">{brand.name}</span>
                }
                {
                    tags.includes('combo_fac') && <span className="InfoBrand badge text-bg-danger">COMBO_FAC</span>
                }
                {
                    tags.includes('photo_requested') &&
                    <span className="photo_request badge">CHỤP ẢNH</span>
                }
                <p><strong>{totalItems}</strong> đơn cần đánh dấu</p>
            </div>
            <div className="rightContent">
                {isMadeInVN &&
                    <span className='mb-2 tagVN'>Made in VN</span>
                }
            </div>
        </div>
        <div className={['ListOrders', `row`].join(' ')}>
            {
                orders.map(order => {
                    const { image, preview_image } = order

                    return <div className={['Order mb-4', `col-md-${maxCols}`].join(' ')} key={order._id}>
                        <div className="OrderInner">
                            {
                                preview_image && <div className="ImagePreview position-relative">
                                    <img src={preview_image} className='previewImage' alt='preview' />
                                    <div className='Actions d-flex justify-content-center align-items-center position-absolute'>
                                        <span className='Icon cursor-pointer mr-2' onClick={() => setVisible(true)}><Icon
                                            type='eye' /></span>
                                    </div>
                                    <Modal visible={visible} closable={false} centered={true} footer={null} width={1200}
                                        onCancel={() => setVisible(false)}>
                                        <div className="Previewer">
                                            <img src={preview_image} alt='preview' className='d-block m-auto' />
                                        </div>
                                    </Modal>
                                </div>
                            }
                        </div>
                    </div>
                })
            }
        </div>

        <div className="Actions mb-4">
            <button type="button" className="btn btn-secondary" onClick={reset}>Hủy</button>
            <button type="button" className="btn btn-primary Mark" onClick={handleMarkPackaged}>Đánh dấu đóng gói
            </button>
        </div>
    </div>
}

export default MarkPackagedPageDetails